module.exports = __webpack_public_path__ + "img/Hypoxia-BLCA_GSE171351.25cef86a.png";